import { useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronLeft, ChevronRight, X } from "lucide-react";
import { useT } from "@/content/i18n";

export const Lightbox = ({ state, onClose, onMove }) => {
  const item = state ? state.items[state.index] : null;
  const t = useT();

  useEffect(() => {
    if (!state) return undefined;
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowRight") onMove(1);
      if (e.key === "ArrowLeft") onMove(-1);
    };
    window.addEventListener("keydown", onKey, true);
    return () => window.removeEventListener("keydown", onKey, true);
  }, [state, onClose, onMove]);

  return (
    <AnimatePresence>
      {item && (
        <motion.div
          data-testid="lightbox"
          className="fixed inset-0 z-[70] flex flex-col items-center justify-center bg-[#0B0908]/92 p-4 backdrop-blur-md sm:p-10"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={onClose}
        >
          <motion.img
            key={item.src}
            src={item.src}
            alt={item.caption}
            className="max-h-[78vh] max-w-full rounded-2xl object-contain shadow-2xl"
            initial={{ opacity: 0, scale: 0.97 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.4 }}
            onClick={(e) => e.stopPropagation()}
          />
          <p data-testid="lightbox-caption" className="mt-4 text-center text-sm text-[#C5BDB3]">{item.caption}</p>
          <button data-testid="lightbox-close-button" className="icon-btn is-close absolute right-4 top-4" onClick={onClose} aria-label={t("close")}><X className="h-4 w-4" /></button>
          <button data-testid="lightbox-prev-button" className="icon-btn absolute left-3 top-1/2" onClick={(e) => { e.stopPropagation(); onMove(-1); }} aria-label={t("prevImg")}><ChevronLeft className="h-4 w-4" /></button>
          <button data-testid="lightbox-next-button" className="icon-btn absolute right-3 top-1/2" onClick={(e) => { e.stopPropagation(); onMove(1); }} aria-label={t("nextImg")}><ChevronRight className="h-4 w-4" /></button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
